/* Filtro de quantidade para coleções "Kits de Calcinha".
 *
 * A quantidade vem exclusivamente do padrão "Kit com N" no título. Como o
 * Shopify não oferece faceta nativa por título, reunimos as páginas já
 * renderizadas pela Section Rendering API. Assim, os cards, a ordenação e os
 * filtros nativos (estoque, tamanho, cor etc.) continuam sendo os do tema.
 */
(function () {
  "use strict";

  var PARAM = "kit_quantity";
  var PAGE_PARAM = "kit_page";
  var ALLOWED = ["2", "3", "6", "10"];
  var PAGE_SIZE = 24;
  var cache = new Map();

  function quantityFromTitle(title) {
    var match = String(title || "").match(/\bkit\s+com\s+(2|3|6|10)\b/i);
    return match ? match[1] : "";
  }

  function countByQuantity(records) {
    var counts = { 2: 0, 3: 0, 6: 0, 10: 0 };
    (records || []).forEach(function (record) {
      if (Object.prototype.hasOwnProperty.call(counts, record.quantity))
        counts[record.quantity] += 1;
    });
    return counts;
  }

  function filterBySelected(records, selected) {
    if (!selected || selected.length === 0) return (records || []).slice();
    return (records || []).filter(function (record) {
      return selected.indexOf(record.quantity) >= 0;
    });
  }

  window.SCKitQuantityFilter = {
    quantityFromTitle: quantityFromTitle,
    countByQuantity: countByQuantity,
    filterBySelected: filterBySelected,
  };
  if (typeof document === "undefined") return;

  function selectedFromUrl() {
    var params = new URL(window.location.href).searchParams;
    var selected = [];
    params.getAll(PARAM).forEach(function (value) {
      if (ALLOWED.indexOf(value) >= 0 && selected.indexOf(value) < 0) selected.push(value);
    });
    return selected;
  }

  function pageFromUrl(max) {
    var page = Number(new URL(window.location.href).searchParams.get(PAGE_PARAM)) || 1;
    return Math.max(1, Math.min(page, Math.max(1, max || 1)));
  }

  function baseUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete(PARAM);
    url.searchParams.delete(PAGE_PARAM);
    url.searchParams.delete("page");
    url.searchParams.delete("section_id");
    return url;
  }

  function recordsFromRoot(root) {
    return Array.prototype.map.call(root.querySelectorAll("[data-product-card]"), function (card) {
      var titleNode = card.querySelector(".product-card__title");
      var title = titleNode ? titleNode.textContent.trim() : "";
      return { title: title, quantity: quantityFromTitle(title), html: card.outerHTML };
    });
  }

  function parseSection(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var root = doc.querySelector("[data-collection-root]");
    if (!root) throw new Error("Resposta da coleção sem data-collection-root.");
    return recordsFromRoot(root);
  }

  async function fetchPage(url, sectionId, page) {
    var target = new URL(url.toString());
    target.searchParams.set("page", String(page));
    target.searchParams.set("section_id", sectionId);
    var response = await fetch(target.toString(), { headers: { Accept: "text/html" } });
    if (!response.ok)
      throw new Error("HTTP " + response.status + " ao carregar página " + page + ".");
    return parseSection(await response.text());
  }

  function loadInventory(root) {
    var url = baseUrl();
    var sectionId = root.getAttribute("data-section-id");
    var key = url.pathname + "?" + url.searchParams.toString() + "#section=" + sectionId;
    if (cache.has(key)) return cache.get(key);

    var totalPages = Math.max(1, Number(root.getAttribute("data-collection-pages")) || 1);
    var currentPage = Math.max(1, Number(root.getAttribute("data-collection-page")) || 1);
    var promise = (async function () {
      var pages = new Array(totalPages);
      if (currentPage <= totalPages) pages[currentPage - 1] = recordsFromRoot(root);

      var queue = [];
      for (var page = 1; page <= totalPages; page += 1) {
        if (page !== currentPage) queue.push(page);
      }
      var cursor = 0;
      async function worker() {
        while (cursor < queue.length) {
          var pageNumber = queue[cursor];
          cursor += 1;
          pages[pageNumber - 1] = await fetchPage(url, sectionId, pageNumber);
        }
      }
      var workers = [];
      var workerCount = Math.min(4, queue.length);
      for (var i = 0; i < workerCount; i += 1) workers.push(worker());
      await Promise.all(workers);
      return pages.reduce(function (all, pageRecords) {
        return all.concat(pageRecords || []);
      }, []);
    })();

    cache.set(key, promise);
    promise.catch(function () {
      cache.delete(key);
    });
    return promise;
  }

  function hydrateInputs(root, selected) {
    root.querySelectorAll("[data-kit-quantity]").forEach(function (input) {
      input.checked = selected.indexOf(input.value) >= 0;
    });
  }

  function syncActiveUi(root, selected) {
    var nativeCount = Number(root.getAttribute("data-native-active-count")) || 0;
    var total = nativeCount + selected.length;
    var filterButton = root.querySelector("[data-filter-open]");
    var buttonCount = filterButton && filterButton.querySelector(".ct-btn__count");
    if (filterButton && total > 0 && !buttonCount) {
      buttonCount = document.createElement("span");
      buttonCount.className = "ct-btn__count";
      filterButton.appendChild(buttonCount);
    }
    if (buttonCount) {
      buttonCount.textContent = total > 0 ? "(" + total + ")" : "";
      buttonCount.hidden = total === 0;
    }

    var drawerTitle = root.querySelector(".filter-drawer__title");
    if (drawerTitle) drawerTitle.textContent = total > 0 ? "Filtros (" + total + ")" : "Filtros";
    var group = root.querySelector("[data-kit-quantity-group]");
    var selectedCount = group && group.querySelector("[data-kit-selected-count]");
    var clear = group && group.querySelector("[data-kit-clear]");
    if (selectedCount) {
      selectedCount.textContent = String(selected.length);
      selectedCount.hidden = selected.length === 0;
    }
    if (clear) clear.hidden = selected.length === 0;
    if (group && selected.length > 0) group.open = true;
  }

  function updateCounts(root, records) {
    var counts = countByQuantity(records);
    ALLOWED.forEach(function (quantity) {
      var countNode = root.querySelector('[data-kit-count="' + quantity + '"]');
      var input = root.querySelector('[data-kit-quantity="' + quantity + '"]');
      var row = input && input.closest(".filter-list__row");
      if (countNode) countNode.textContent = String(counts[quantity]);
      if (input) input.disabled = counts[quantity] === 0 && !input.checked;
      if (row) row.classList.toggle("is-disabled", counts[quantity] === 0 && !input.checked);
    });
    var group = root.querySelector("[data-kit-quantity-group]");
    if (group) group.setAttribute("aria-busy", "false");
    var loading = root.querySelector("[data-kit-loading]");
    if (loading) loading.textContent = "Contagens dos kits carregadas.";
  }

  function removeProductPagination(root) {
    root.querySelectorAll(".pagination").forEach(function (pagination) {
      pagination.remove();
    });
  }

  function renderPagination(root, currentPage, totalPages) {
    if (totalPages <= 1) return;
    var grid = root.querySelector("[data-collection-grid]");
    if (!grid) return;
    var nav = document.createElement("nav");
    nav.className = "pagination kit-pagination";
    nav.setAttribute("data-kit-pagination", "");
    nav.setAttribute("aria-label", "Paginação dos kits filtrados");

    function button(label, page, className, disabled, current) {
      var element = document.createElement("button");
      element.type = "button";
      element.className = className;
      element.textContent = label;
      element.setAttribute("data-kit-page", String(page));
      if (disabled) element.disabled = true;
      if (current) element.setAttribute("aria-current", "page");
      return element;
    }

    nav.appendChild(
      button("‹ Anterior", currentPage - 1, "pagination__nav", currentPage === 1, false),
    );
    var list = document.createElement("ul");
    list.className = "pagination__pages";
    for (var page = 1; page <= totalPages; page += 1) {
      var item = document.createElement("li");
      item.appendChild(
        button(
          String(page),
          page,
          "pagination__page" + (page === currentPage ? " is-current" : ""),
          false,
          page === currentPage,
        ),
      );
      list.appendChild(item);
    }
    nav.appendChild(list);
    nav.appendChild(
      button("Próximo ›", currentPage + 1, "pagination__nav", currentPage === totalPages, false),
    );
    grid.insertAdjacentElement("afterend", nav);
  }

  function updateResultLabels(root, total, currentPage, totalPages) {
    var totalLabel = total + " produto" + (total === 1 ? "" : "s");
    var mobileTotal = root.querySelector(".collection-toolbar__mobile-total");
    if (mobileTotal) mobileTotal.textContent = totalLabel;
    var applyButton = root.querySelector("[data-filter-close-apply]");
    if (applyButton) applyButton.textContent = "Ver " + totalLabel;
    var pageLabel = root.querySelector(".collection-hero__count");
    if (pageLabel)
      pageLabel.textContent = "Página " + currentPage + (totalPages > 1 ? " de " + totalPages : "");
  }

  function renderResults(root, records) {
    var selected = selectedFromUrl();
    if (selected.length === 0) return;
    var filtered = filterBySelected(records, selected);
    var totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    var currentPage = pageFromUrl(totalPages);
    var start = (currentPage - 1) * PAGE_SIZE;
    var grid = root.querySelector("[data-collection-grid]");
    if (!grid) return;

    removeProductPagination(root);
    grid.innerHTML = filtered
      .slice(start, start + PAGE_SIZE)
      .map(function (record) {
        return record.html;
      })
      .join("");
    grid.classList.remove("is-busy");
    var oldEmpty = root.querySelector("[data-kit-empty]");
    if (oldEmpty) oldEmpty.remove();
    if (filtered.length === 0) {
      var empty = document.createElement("div");
      empty.className = "empty-state";
      empty.setAttribute("data-kit-empty", "");
      empty.textContent = "Nenhum kit encontrado para as quantidades selecionadas.";
      grid.insertAdjacentElement("afterend", empty);
    } else {
      renderPagination(root, currentPage, totalPages);
    }
    updateResultLabels(root, filtered.length, currentPage, totalPages);
    if (window.initSwatches) window.initSwatches(root);
  }

  function showLoadError(root) {
    var group = root.querySelector("[data-kit-quantity-group]");
    if (group) group.setAttribute("aria-busy", "false");
    root.querySelectorAll("[data-kit-count]").forEach(function (node) {
      node.textContent = "—";
    });
    var loading = root.querySelector("[data-kit-loading]");
    if (loading) loading.textContent = "Não foi possível carregar as contagens. Tente novamente.";
  }

  function ensureInventory(root) {
    if (!root || !document.documentElement.contains(root)) return Promise.resolve([]);
    if (root.__kitInventoryPromise) return root.__kitInventoryPromise;
    var group = root.querySelector("[data-kit-quantity-group]");
    var grid = root.querySelector("[data-collection-grid]");
    if (group) group.setAttribute("aria-busy", "true");
    if (selectedFromUrl().length > 0 && grid) grid.classList.add("is-busy");
    root.__kitInventoryPromise = loadInventory(root)
      .then(function (records) {
        if (!document.documentElement.contains(root)) return records;
        root.__kitInventory = records;
        updateCounts(root, records);
        renderResults(root, records);
        return records;
      })
      .catch(function (error) {
        console.error("Falha ao carregar o filtro de quantidade dos kits.", error);
        root.__kitInventoryPromise = null;
        if (document.documentElement.contains(root)) showLoadError(root);
        throw error;
      });
    return root.__kitInventoryPromise;
  }

  function initRoot(root) {
    if (!root || root.getAttribute("data-kit-filter-ready") === "1") return;
    root.setAttribute("data-kit-filter-ready", "1");
    var selected = selectedFromUrl();
    hydrateInputs(root, selected);
    syncActiveUi(root, selected);
    if (selected.length > 0) ensureInventory(root).catch(function () {});
  }

  function currentRoot() {
    return document.querySelector("[data-collection-root][data-kit-quantity-filter]");
  }

  document.addEventListener("click", function (event) {
    var root = currentRoot();
    if (!root) return;
    if (event.target.closest("[data-filter-open]")) {
      ensureInventory(root).catch(function () {});
      return;
    }
    var clear = event.target.closest("[data-kit-clear]");
    if (clear) {
      event.preventDefault();
      event.stopPropagation();
      var inputs = root.querySelectorAll("[data-kit-quantity]");
      inputs.forEach(function (input) {
        input.checked = false;
      });
      if (inputs[0]) inputs[0].dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
    var pageButton = event.target.closest("[data-kit-page]");
    if (pageButton && !pageButton.disabled && root.__kitInventory) {
      event.preventDefault();
      var url = new URL(window.location.href);
      url.searchParams.set(PAGE_PARAM, pageButton.getAttribute("data-kit-page"));
      window.history.replaceState(null, "", url.toString());
      renderResults(root, root.__kitInventory);
      var grid = root.querySelector("[data-collection-grid]");
      if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  document.addEventListener("pointerover", function (event) {
    if (!event.target.closest("[data-filter-open]")) return;
    var root = currentRoot();
    if (root) ensureInventory(root).catch(function () {});
  });

  function boot() {
    document.querySelectorAll("[data-collection-root][data-kit-quantity-filter]").forEach(initRoot);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches("[data-collection-root][data-kit-quantity-filter]"))
            initRoot(node);
          if (node.querySelectorAll)
            node
              .querySelectorAll("[data-collection-root][data-kit-quantity-filter]")
              .forEach(initRoot);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
